import 'css-chunksrc/client/scenes/project/resources/styles.scss';export default {
  "header": "_header_1hpfx_1",
  "title": "_title_1hpfx_8",
  "main": "_main_1hpfx_14",
  "list": "_list_1hpfx_25"
};